import Vue from 'vue';
import AddManyContacts from '../components/AddManyContacts';
import GroupListingTable from '../components/tables/GroupsListingTable';
import SnappyDropdown from '../components/SnappyDropdown';
import ExportContacts from '../components/ExportContacts';
import EnrichAllContactsModal from '../components/EnrichAllContactsModal.vue';

Vue.component('manage-groups', {
  components: {AddManyContacts, GroupListingTable, SnappyDropdown, ExportContacts ,EnrichAllContactsModal},
  data() {
    return {
      modalOpen: false,
    };
  },
  methods: {
    onDoAction(name) {
      if (name === 'export') this.$refs.export.$el.click();
      if (name === 'importFromFile') this.$refs.importFromFile.$refs.trigger.click();
      if (name === 'enrich-all') this.modalOpen = true;
    },
  },
  props: {
    redtailStatus: {
      type: Boolean,
      required: true,
    },
    salesforceStatus: {
      type: Boolean,
      required: true,
    },
  },
});
